import * as types from "./index";
import { RieventSSOTokenRequest } from "../services/cmeLaunchService";

export const cmeLaunchAction = (cmeLaunchRequest: RieventSSOTokenRequest) => ({
  type: types.CME_LAUNCH_GET_TOKEN,
  cmeLaunchRequest,
});
